import * as React from "react";
import Grid from "@mui/material/Grid";
import {
    FormHelperText,
    InputAdornment,
    InputLabel,
    TextField
} from "@mui/material";
import Button from "@mui/material/Button";
import {Refresh, ContentCopy, Save} from "@mui/icons-material";
import helpers from "../../helpers/common";
import projects from "../../models/projects";
import {useEffect, useState} from "react";
import useRootHook from "../../hooks/useRoot";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";

export default function ProjectEditAPI ({project, refresh}) {
    const [fields, setFields] = useState({...project})
    const [errors, setErrors] = useState({})
    const {setShowLoader, notify, userData, showConfirm} = useRootHook()
    
    // Только админ и супер админ могут редактировать
    const canEdit = userData?.role === helpers.roles.A || userData?.role === helpers.roles.S

    useEffect(() => {
        if (!project) return
        if (!project.secret_key) {
            setNewKey()
        }
        setFields({
            id: project.id,
            secret_key: project.secret_key,
            webhook: project.webhook
        })
    }, [project])

    const setNewKey = () => {
        projects.setNewSecretKey(project.id)
            .then(() => {
                refresh()
            })
            .catch()
    }

    const handleCopy = (text) => {
        helpers.copyTextToClipboard(text)
            .then(() => {
                notify('Key copied to Clipboard', 2000)
            })
    }

    if (!project) return null

    const handleChange = (ev) => {
        if (!canEdit) return // Блокируем изменения для мерчантов
        
        const [, value, name] = helpers.getFormEventData(ev);

        setErrors({...errors, [name]: undefined});

        setFields((prevState) => {
            let newFields = {...prevState}
            newFields[name] = value

            return newFields
        })
    }

    const handleBlur = (ev) => {
        if (!canEdit) return // Блокируем валидацию для мерчантов
        
        const [, , name] = helpers.getFormEventData(ev)

        const newErrors = {...errors}
        const newFields = {...fields}

        typeof projects.fieldValidator[name] === 'function'
        && projects.fieldValidator[name](newFields, newErrors)

        setFields(newFields)

        setErrors(newErrors)
    }

    const handleSubmit = (ev) => {
        ev.preventDefault()
        if (!canEdit) {
            notify('Only admins can edit projects', 3000)
            return
        }
        
        const validationErrors = projects.methodValidator.editAPI(fields)
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length !== 0) return

        setShowLoader(true)
        projects.editAPI(fields)
            .then(() => {
                setShowLoader(false)
                notify('Project updated')
                refresh()
                //navigate('/merchants')
            }).catch(() => setShowLoader(false))
    }

    return <React.Fragment>
        <Grid container spacing={2}
              component="form"
              onSubmit={handleSubmit}
              autoComplete="off"
        >
            <Grid size={12}>
                <InputLabel>Webhook URL (HTTPS POST JSON)</InputLabel>
                <TextField
                    error={!!errors.webhook}
                    value={fields.webhook || ""}
                    name="webhook"
                    id="webhook"
                    required={true}
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={!canEdit}
                    InputProps={{
                        readOnly: !canEdit
                    }}
                />
                {errors.webhook && <FormHelperText>{errors.webhook}</FormHelperText>}
            </Grid>
            <Grid size={12}>
                <InputLabel>Secret Key</InputLabel>
                <TextField
                    error={!!errors.secret_key}
                    value={fields.secret_key || ""}
                    name="secret_key"
                    id="secret_key"
                    required={true}
                    fullWidth={true}
                    InputProps={{
                        readOnly: true,
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="Copy key"
                                    edge="start"
                                    onClick={() => handleCopy(fields.secret_key)}
                                >
                                    <ContentCopy />
                                </IconButton>
                                <Divider orientation="vertical" flexItem />
                                <IconButton
                                    aria-label="Set new key"
                                    edge="end"
                                    disabled={!canEdit}
                                    onClick={async () => {
                                        const confirmed = await showConfirm(
                                            'A new secret key will be set if you confirm. Are you sure you want to proceed?',
                                            'Set New Secret Key'
                                        );
                                        if (confirmed) setNewKey();
                                    }}
                                >
                                    <Refresh />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                {errors.secret_key && <FormHelperText>{errors.secret_key}</FormHelperText>}
            </Grid>
            {canEdit && (
                <Grid container spacing={3} sx={{mt: 2}} size={12}>
                    <Grid size={{ xs: 6 }}>
                        <Button type="submit" onClick={handleSubmit} variant="outlined" startIcon={<Save />} >
                            Save
                        </Button>
                    </Grid>
                </Grid>
            )}
        </Grid>
    </React.Fragment>
}
